import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import {withdrawalsHistory} from '../Request/Histories';
import { accountBalance, referralBalance, bonusBalance } from '../Request/Wallets';

const Withdrawal = () => {

    let totalWithdrawalbles = accountBalance() + referralBalance() + bonusBalance();

    let myWithdrawalHistory = withdrawalsHistory();

    const [pendingWithdrawals, setPendingWithdrawal] = useState(0);
    const [activeWithdrawal, setActiveWithdrawal] = useState(0);
    const [completedWithdrawal, setcompletedWithdrawal] = useState(0);
    const getDate = (date) => new Date(date).toDateString();

    const getAmount = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'accounting' }).format(amount);
   
   
    useEffect(() => {
        document.title = 'WITHDRAWAL';
        myWithdrawalHistory = withdrawalsHistory();
        totalWithdrawalbles = accountBalance() + referralBalance() + bonusBalance();

        let pendingNum = 0;        
        let activeNum = 0;        
        let completedNum = 0;  

        myWithdrawalHistory.forEach(Withdrawal => {
                
                if (Withdrawal.status === 'approved') {
                    activeNum += parseInt(Withdrawal.amount);
                }
                if (Withdrawal.status === 'completed') {
                    completedNum += parseInt(Withdrawal.amount);
                }
                if (Withdrawal.status === 'pending') {
                    pendingNum += parseInt(Withdrawal.amount);
                }
                if (Withdrawal.status === 'waiting approval') {
                    pendingNum += parseInt(Withdrawal.amount);
                }
            
        });
        
        setActiveWithdrawal(activeNum);
        setcompletedWithdrawal(completedNum);
        setPendingWithdrawal(pendingNum);
        
        if(window && window.init_template){
            window.init_template();
        }  
    }, [myWithdrawalHistory, activeWithdrawal, completedWithdrawal, pendingWithdrawals]);

  return (
    <div className="withdrawal-page-root">
        <style>{`
            .withdrawal-page-root {
                padding: 1.5rem;
                font-family: 'Poppins', 'Inter', sans-serif;
            }
            .wd-stats-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
                gap: 1.5rem;
                margin-bottom: 2rem;
            }
            .wd-stat-card {
                background: rgba(30, 30, 30, 0.7);
                border-radius: 16px;
                padding: 1.5rem;
                backdrop-filter: blur(10px);
                border: 1px solid rgba(255, 255, 255, 0.05);
                transition: all 0.3s ease;
                position: relative;
                overflow: hidden;
            }
            .wd-stat-card:hover {
                transform: translateY(-5px);
                box-shadow: 0 10px 30px rgba(0, 242, 254, 0.2);
                border-color: rgba(0, 242, 254, 0.3);
            }
            .wd-stat-card::before {
                content: '';
                position: absolute;
                inset: 0;
                background: radial-gradient(circle at 70% 20%, rgba(0, 242, 254, 0.1) 0%, transparent 70%);
                pointer-events: none;
            }
            .wd-stat-icon {
                width: 64px; height: 64px;
                border-radius: 14px;
                display: flex; align-items: center; justify-content: center;
                margin-bottom: 1.25rem;
                background: linear-gradient(135deg, rgba(0,180,180,0.35) 0%, rgba(0,100,120,0.55) 100%);
                color: #00f5ff;
                font-size: 1.75rem;
                box-shadow: 0 4px 18px rgba(0,242,254,0.18);
            }
            .wd-stat-value {
                font-size: 1.75rem;
                font-weight: 600;
                margin: 0.5rem 0;
                background: linear-gradient(135deg, #00f2fe 0%, #00f5ff 100%);
                -webkit-background-clip: text;
                background-clip: text;
                -webkit-text-fill-color: transparent;
            }
            .wd-stat-label {
                color: #b0b0b0;
                font-size: 0.9rem;
                margin: 0;
            }
            .wd-stat-meta {
                color: #b0b0b0;
                font-size: 0.75rem;
                margin-top: 0.5rem;
                opacity: 0.7;
            }
        `}</style>

        <div className="wd-stats-grid">
            <div className="wd-stat-card">
                <div className="wd-stat-icon"><i className="fas fa-wallet"></i></div>
                <h4 className="wd-stat-value">{getAmount(totalWithdrawalbles)}</h4>
                <p className="wd-stat-label">Total Withdrawable</p>
                <p className="wd-stat-meta">updated now</p>
            </div>
            <div className="wd-stat-card">
                <div className="wd-stat-icon"><i className="fas fa-check-circle"></i></div>
                <h4 className="wd-stat-value">{getAmount(activeWithdrawal)}</h4>
                <p className="wd-stat-label">Approved Withdrawals</p>
                <p className="wd-stat-meta">updated now</p>
            </div>
            <div className="wd-stat-card">
                <div className="wd-stat-icon"><i className="fas fa-hourglass-half"></i></div>
                <h4 className="wd-stat-value">{getAmount(pendingWithdrawals)}</h4>
                <p className="wd-stat-label">Pending Withdrawals</p>
                <p className="wd-stat-meta">updated now</p>
            </div>
        </div>

        <div className="row text-center mt-4">        
            <div className="col-12 mb-n2 text-start">
                <Link to="/withdrawal" data-bs-toggle="offcanvas" data-bs-target="#menu-withdrawal" className="default-link card card-style mx-0" style={{height: "90px"}}>
                    <div className="card-center px-4 ">
                        <div className="d-flex">
                            <div className="align-self-center">
                                <span className="icon icon-m rounded-s gradient-green shadow-bg shadow-bg-xs">
                                <i translate="no" className="material-icons-outlined color-white" style={{fontSize: "28px", marginTop: "11px"}}>money_off_csred</i>
                                </span>
                            </div>
                            <div className="align-self-center ps-3 ms-1">
                                <h1 className="font-20 mb-n1">Request Withdrawal</h1>
                                <p className="mb-0 font-12 opacity-70">Withdraw your earnings</p>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>		
        </div>        

        <div className="card card-style mx-0">
           <div className="content mb-0">
               <div className="tabs tabs-pill" id="lend-customers">
                   <div className="tab-controls rounded-m p-1 overflow-visible">
                       <a className="font-13 rounded-s py-1 shadow-bg shadow-bg-s" data-bs-toggle="collapse" href="/#pending-customers" aria-expanded="true">Pending</a>
                       <a className="font-13 rounded-s py-1 shadow-bg shadow-bg-s" data-bs-toggle="collapse" href="/#active-customers" aria-expanded="false">Approved</a>
                       <a className="font-13 rounded-s py-1 shadow-bg shadow-bg-s" data-bs-toggle="collapse" href="/#completed-customers" aria-expanded="false">Declined</a>
                   </div>
                   <div className="mt-3"></div>
                   {/* <!-- Tab Bills List --> */}
                <div className="collapse show" id="pending-customers" data-bs-parent="#lend-customers">
                    <h6 className="text-center opacity-30 pb-3">Tap an Item below for More Details </h6>
                    <div className="content mt-0 mb-0">
                        {!pendingWithdrawals > 0 ?
                        <div className="card card-style alert alert-dismissible border border-fade-yellow show fade p-0 mb-3">
                            <div className="content my-3">
                                <div className="d-flex">
                                    <div className="align-self-center no-click">
                                        <i className="bi bi-exclamation-triangle font-36 color-yellow-dark d-block"></i>
                                    </div>
                                    <div className="align-self-center no-click">
                                        <p className="color-yellow-dark mb-0 font-500 font-14 ps-3 pe-4 line-height-s">
                                            No pending Withdrawal records found for now
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                            myWithdrawalHistory.map(Withdrawal =>(
                                (Withdrawal.status === 'pending' || Withdrawal.status === 'waiting approval') &&
                                <Link key={Withdrawal.id} data-bs-toggle="offcanvas" data-bs-target="#borrow-history-menu"  to="#" className="d-flex pb-3">
                                    <div className="align-self-center">
                                        <span className="icon rounded-s me-2 gradient-red shadow-bg shadow-bg-xs"><i className="bi bi-droplet font-18 color-white"></i></span>
                                    </div>
                                    <div className="align-self-center ps-1">
                                        <h5 className="pt-1 mb-n1">{getAmount(Withdrawal.amount)}</h5>
                                        <p className="mb-0 font-11 opacity-50">{getDate(Withdrawal.created_at)}</p>
                                    </div>
                                    <div className="align-self-center ms-auto text-end">
                                        <h4 className="pt-1 mb-n1 color-red-dark">{Withdrawal.wallet_name}</h4>
                                        <p className="mb-0 font-12 opacity-50">{Withdrawal.status}</p>
                                    </div>
                                </Link>
                            ))                
                                       
                        }
                    </div>                                          
            </div>

            <div className="collapse" id="active-customers" data-bs-parent="#lend-customers">
                    <h6 className="text-center opacity-30 pb-3">Tap an Item below for More Details </h6>
                    <div className="content mt-0 mb-0">
                        {!activeWithdrawal > 0 ?
                        <div className="card card-style alert alert-dismissible border border-fade-yellow show fade p-0 mb-3">
                            <div className="content my-3">
                                <div className="d-flex">
                                    <div className="align-self-center no-click">
                                        <i className="bi bi-exclamation-triangle font-36 color-yellow-dark d-block"></i>
                                    </div>
                                    <div className="align-self-center no-click">
                                        <p className="color-yellow-dark mb-0 font-500 font-14 ps-3 pe-4 line-height-s">
                                            No active Withdrawal records found for now
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                            myWithdrawalHistory.map(Withdrawal =>(
                                Withdrawal.status === 'approved' &&
                                <Link key={Withdrawal.id} data-bs-toggle="offcanvas" data-bs-target="#borrow-history-menu"  to="#" className="d-flex pb-3">
                                    <div className="align-self-center">
                                        <span className="icon rounded-s me-2 gradient-green shadow-bg shadow-bg-xs"><i className="bi bi-droplet font-18 color-white"></i></span>
                                    </div>
                                    <div className="align-self-center ps-1">
                                        <h5 className="pt-1 mb-n1">{getAmount(Withdrawal.amount)}</h5>
                                        <p className="mb-0 font-11 opacity-50">{getDate(Withdrawal.created_at)}</p>
                                    </div>
                                    <div className="align-self-center ms-auto text-end">
                                        <h4 className="pt-1 mb-n1 color-green-dark">{Withdrawal.wallet_name}</h4>
                                        <p className="mb-0 font-12 opacity-50">{Withdrawal.status}</p>
                                    </div>
                                </Link>
                            ))                
                                    
                        }
                    </div>                                          
            </div>
            
            {/* <!-- Tab Custom Payments--> */}
            <div className="collapse" id="completed-customers" data-bs-parent="#lend-customers">
                <h6 className="text-center opacity-30 pb-3">Tap an Item below for More Details </h6>
                <div className="content mt-0 mb-0">
                    {!completedWithdrawal > 0 ?
                    <div className="card card-style alert alert-dismissible border border-fade-yellow show fade p-0 mb-3">
                        <div className="content my-3">
                            <div className="d-flex">
                                <div className="align-self-center no-click">
                                    <i className="bi bi-exclamation-triangle font-36 color-yellow-dark d-block"></i>
                                </div>
                                <div className="align-self-center no-click">
                                    <p className="color-yellow-dark mb-0 font-500 font-14 ps-3 pe-4 line-height-s">
                                        No completed Withdrawals record avaialable
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                        myWithdrawalHistory.map(Withdrawal =>(
                            Withdrawal.status === 'completed' &&
                            <Link key={Withdrawal.id} data-bs-toggle="offcanvas" data-bs-target="#borrow-history-menu"  to="#" className="d-flex pb-3">
                                <div className="align-self-center">
                                    <span className="icon rounded-s me-2 gradient-green shadow-bg shadow-bg-xs"><i className="bi bi-droplet font-18 color-white"></i></span>
                                </div>
                                <div className="align-self-center ps-1">
                                    <h5 className="pt-1 mb-n1">{getAmount(Withdrawal.amount)}</h5>
                                    <p className="mb-0 font-11 opacity-50">{getDate(Withdrawal.created_at)}</p>
                                </div>
                                <div className="align-self-center ms-auto text-end">
                                    <h4 className="pt-1 mb-n1 color-theme">{Withdrawal.wallet_name}</h4>
                                    <p className="mb-0 font-12 opacity-50">{Withdrawal.status}</p>
                                </div>
                            </Link>
                        ))                
                    
                    }
                </div>                   
                </div>
               </div>
           </div>
        </div>
    </div>
  )
}

export default Withdrawal